import {has} from 'lodash' // import lodash
import $ from 'jquery'

export default {
  increment(state){
    state.index++
  },
  setCategory(state,val){
    state.dataList.category = val.category;
  },
  setIdentity(state,val){
    state.dataList.identity = val.identity;
  },
  setEntity(state,val){
    state.dataList.entity = val.entity;
  },
  setSearch(state,val){
    state.dataList.search = val.search;
  },
  setPerPage(state,val){
    state.dataList.perPage = val.perPage;
  },
  setCurrentPage(state,val){
    state.dataList.currentPage = val.currentPage;
  },
   setDataFields(state,val){
    state.dataList.fields = val.fields;
  },
  setDataColumns(state,val){
    state.dataList.columns = val.columns;
  },
  setDataTotal(state,val){
    state.dataList.total = val.total;
  },
  setDataList(state,val){
    state.dataList.list = val.list;
  },
  updateActionData(state,val){
    state.dataAction.data = val.data;
  },
  updateActionID(state,val){
    state.dataAction.ID = val.rowID;
    state.dataAction.type = val.action;
  }

}


// WEBPACK FOOTER //
// ./src/Adm/EntityManagement/store/mutations.js